
import Vue from "vue";
import { baseVueController } from "./baseVueController";
import { ajax, common, constDialogMessage, dialogUtil,idb } from "./util";
import * as es6promise from "es6-promise";
import { AddOrder, AddOrderList } from "./entity/addOrderEntity";
import { Logger } from "./util/logger";
import { MultiTab } from "./util/multitab";
import { orderInfo } from "./entity/idb/orderInfo";
import { util } from ".";
import { SSO } from "./util/sso";

var that: any; // = this

// gigya
declare var gigya: any;

//------------------------------------------------------------------------------
// クラス
//------------------------------------------------------------------------------
/**
 * 追加注文画面コントローラクラス
 * */
export class addOrderController extends baseVueController {


	//--------------------------------------------------------------------------
	// 定数
	//--------------------------------------------------------------------------
	private readonly ELEMENT_NAME: string = "#addOrderController";

	// WebAPIのエンドポイント定義
	private readonly WebAPI_GetList: string = "Addorder/GetList";
	private readonly WebAPI_GetEditImage: string = "edit/GetEditThumb";

	private readonly WebAPI_OcapiLogin: string = "Login/Ocapi";
	private readonly WebAPI_GIGYALogin: string = "Login/GIGYA";

	// 画面URL
	private readonly ViewURL_Edit: string = "Edit";
	private readonly ViewURL_Preview: string = "Preview";

	// idb関連
	private readonly EDIT_INFO_STORENAME = "editInfo";
	private readonly ORDER_INFO_STORENAME = "orderInfo";
	private readonly MASTER_INFO_STORENAME = "masterInfo";

	// 印刷タイプ
	private readonly INSATSU: string = "1";
	private readonly GINEN: string = "2";

	//--------------------------------------------------------------------------
	// 変数
	//--------------------------------------------------------------------------

	// トークン
	private _token: string;

	/**
	 * ロゴ１ URL
	 */
	private _logo1Url: string;
	/**
	 * ロゴ２ URL
	 */
	private _logo2Url: string;

	//--------------------------------------------------------------------------
	// プロパティ
	//--------------------------------------------------------------------------

	//--------------------------------------------------------------------------
	// コンストラクタ
	//--------------------------------------------------------------------------

	//--------------------------------------------------------------------------
	// メソッド
	//--------------------------------------------------------------------------
	/**
	 * 初期化メソッド
	 * */
	public init(): void {

		// 複数タブ禁止
		const multiTabCheck = () => {
			MultiTab.forbiddenMultiTab(() => {
				dialogUtil.createErrorDialog(constDialogMessage.WARNING_MULTITAB_FORBIDDEN
					, () => { }
					, null
					, true
				);
			})
		}
		setInterval(multiTabCheck, MultiTab.INTERVAL);

		// エラー時のボタン遷移先
		this.SetErrorPageInfo();

		// gigya イベントリスナー登録
		if (this._retailerConfig.id == "0") {
			gigya.socialize.addEventHandlers({
				onLogin: this.onLoginHandler
				//onHide: common.onHideHandler
			});
		}

		// リテーラ毎の処理
		this.initRetailer();

		// vueオブジェクト生成
		this._vue = new Vue({
			el: this.ELEMENT_NAME,
			data: {
				// 注文済み一覧
				orderInfos: [],
				// 読み込み済み状態保持
				orderImgComplete: [],
				// ヘッダーメニュー
				Header: {
					Logo1Url: this._logo1Url,
					Logo2Url: this._logo2Url,
				},
			},
			methods: {
				// 戻るボタン
				btnClickReturnFlow: (event: JQueryEventObject) => {
					this.btnClickReturnFlow(event);
				},
				// 次へボタン
				btnClickNextFlow: (event: JQueryEventObject) => {
					this.btnClickNextFlow(event);
				},
				// 画像url設定
				getImgUrl: (order: AddOrder) => {
					return this.getImgUrl(order);
				},
				// 画像読み込み
				imgOnload: () => {
					this.updateOrderImgComplete();
				},
				// 再注文
				reOrder: (order: AddOrder) => {
					this.reOrder(order);
				},
				// コピーして再編集
				reEdit: (order: AddOrder) => {
					this.reEdit(order);
				},
				// ヘッダー
				btnClickReturnTop: (event: JQueryEventObject) => {
					this.btnClickReturnTop(event);
				},
				btnClickFaq: (event: JQueryEventObject) => {
					this.btnClickFaq(event);
				},
				btnClickOrderHistory: (event: JQueryEventObject) => {
					this.btnClickOrderHistory(event);
				}
			}, mounted: () => {

				// リテーラ別のチャットボット制御
				var divChatBot = document.getElementById("chava-root") as HTMLDivElement;
				if (divChatBot) {
					divChatBot.style.display = this._retailerConfig.id == "0" ? "block" : "none";
				}

				// DOM読み込み後
				this.doOnload();
			}
		});
	}

	/**
	 * 画面の初期化
	 * */
	public async doOnload(): es6promise.Promise<void> {

		that = this;

		// commonのコールバックを無効化
		common.pleaseQuiet = true;

		// ローディングダイアログ開始
		dialogUtil.showLoading();

		// tokenを画面から確保
		this.getAuthToken();

		// getパラメータの取得
		common.setGetParam();

		// SSO
		Logger.log("SSO開始");
		await SSO.DoSSO(this._token, this._retailerConfig.id);

		// SSO(GIGYA)まち
		await SSO.WaitSSO();

		let isFF = this._retailerConfig.id == "0" ? true : false;

		// ログインチェック
		const isLogin = await common.LoginCheck(this._token);

		if (isFF) {
			// FF
			if (!isLogin) {
				await common.ShowGIGYALogin().finally(() => {
					dialogUtil.closeLoading();
				});
			} else {
				this.afterGIGYACallBack();
			}

		} else {

			if (!isLogin) {
				// OCAPI
				let loginOK = false;
				while (!loginOK) {

					// ログインOKになるまで
					await common.ShowOcapiAndLogin(this._token).then((data) => {
						loginOK = data;
					}).catch((e) => {
						loginOK = e;
					});

				}
			}

			this.afterGIGYACallBack();
		}

	}

	/**
	 * 画面初期化
	 * */
	private async initDisp(): es6promise.Promise<any> {

		// 追加注文画面初期化実行
		var req = {
			token: this._token,
			//customerId: customerId
		}
		Logger.debug("追加注文:API実行します。", req);

		const that = this;
		await ajax.post(this.WebAPI_GetList, JSON.stringify(req)).then((data: AddOrderList) => {

			Logger.debug("追加注文:API実行しました", data);

			// 注文情報なし
			if (data.infos.length == 0) {

				const closeFunc = () => {
					dialogUtil.closeLoading();
					window.location.href = decodeURIComponent($('#CallBackURL').val());
					dialogUtil.closeErrorDialog();
				}
				dialogUtil.createErrorDialog(constDialogMessage.ERROR_ADDORDER_ORDER_NONE, closeFunc, dialogUtil.DialogType.None);

				Promise.resolve();
			}

			// vue変数にバインド
			this._vue.$data.orderInfos = data.infos;

			// img 描画
			this.DrawThumbNail(data);

		}).catch((e) => {

			Logger.debug("追加注文:API実行失敗しました");

			const closeFunc = ()=> {
				dialogUtil.closeErrorDialog();
				dialogUtil.closeLoading();
			}
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_SYSTEM, closeFunc);
			Promise.reject();

		});

	}

	private DrawThumbNail(data: AddOrderList): void {

		let loadCount = 0;
		dialogUtil.showLoading();
		data.infos.forEach(e => {
			// 画像取得
			const param = "saveId=" + e.editId + "&saveId2=" + e.idx + "";
			util.ajax.postforblob_get(this.WebAPI_GetEditImage, param).then((d: Blob) => {
				const img = <HTMLImageElement>document.getElementById(e.orderNo);
				// 画像描画
				if (img) {
					const url = window.URL || window.webkitURL;
					img.src = url.createObjectURL(d);
				}
			}).finally(() => {
				loadCount++;
				if (data.infos.length == loadCount) {
					dialogUtil.closeLoading();
				}
			});
		});

	}

	/**
	 * リテーラ別の初期化処理
	 * */
	public initRetailer(): void {
		// リテーラロゴURL設定
		this._logo1Url = this._retailerConfig.logo1;
		this._logo2Url = this._retailerConfig.logo2;
	}

	/**
	* 認証トークン取得
	*/
	public getAuthToken(): string {

		// hiddenから認証トークン取得＆クリア
		this._token = $("#Token").val();
		//$("#Token").val("");
		return this._token;
	}

	private async onLoginHandler(res: any): es6promise.Promise<any> {

		// ここではthis使えないのでthatで代替

		dialogUtil.showLoading();

		Logger.log('gigya callback 呼び出し。');

		const param = {
			token: that._token,
			uid: res.UID,
			signature: res.UIDSignature,
			sigtimestamp: res.signatureTimestamp,
		};

		// GIGYAログインのシグネイチャ検証
		await ajax.post(that.WebAPI_GIGYALogin, JSON.stringify(param)).catch((e) => {
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_GIGYA_SIGNATURE_INVALID, dialogUtil.closeErrorDialog);
			dialogUtil.closeLoading();
			// 検証失敗。
			throw e;
		});

		// CCとGIGYA間のログイン
		await ajax.postform(that._retailerConfig.extrSettings.commersCloud.gigyaCcBridge, res.UID).catch((e) => {
			dialogUtil.createErrorDialog(constDialogMessage.ERROR_CC_LOGIN_WITH_GIGYA, dialogUtil.closeErrorDialog);
			dialogUtil.closeLoading();
			throw e;
		});

		that.afterGIGYACallBack();
	}

	private async afterGIGYACallBack(): es6promise.Promise<any> {

		// 画面初期化
		dialogUtil.showLoading();
		await that.initDisp().then(() => {

			Logger.debug("追加注文:initDisp完了");

		});
	}
	//--------------------------------------------------------------------------
	// イベント
	//--------------------------------------------------------------------------
	/**
	* 前画面遷移ボタン押下メソッド
	* */
	public btnClickReturnFlow(event: JQueryEventObject): void {
		window.location.href = decodeURIComponent($('#CallBackURL').val());
	}

	/**
	 * 次画面遷移ボタン押下メソッド
	 * */
	public btnClickNextFlow(event: JQueryEventObject): void {
		// NOP

	}

	/**
	 * コピーして再編集
	 * @param order
	 */
	private reEdit(order: AddOrder): void {
		window.location.href = this.ViewURL_Edit + "?saveId=" + encodeURIComponent(order.editId) + "&saveId2=" + encodeURIComponent(order.idx) + "&addorder=" + encodeURIComponent(order.addReOrder);
	}

	/**
	 * 再注文メソッド
	 * @param order
	 */
	private reOrder(order: AddOrder): void {

		if (order.orderStop) {

			let msg = this._retailerConfig.id == "1" ? constDialogMessage.ERROR_DESIGN_PRINTTYPE_GINEN_STOP_TEXT_ADDORDER_KITAMURA : constDialogMessage.ERROR_DESIGN_PRINTTYPE_GINEN_STOP_TEXT_ADDORDER;
			if (order.printType == this.INSATSU) {
				// 印刷不可の場合
				msg = this._retailerConfig.id == "1" ? constDialogMessage.ERROR_DESIGN_PRINTTYPE_INSATSU_STOP_TEXT_ADDORDER_KITAMURA : constDialogMessage.ERROR_DESIGN_PRINTTYPE_INSATSU_STOP_TEXT_ADDORDER;
			}
			// 再注文不可
			dialogUtil.createErrorDialog(msg, dialogUtil.closeErrorDialog);

		} else {
			// 再注文可能
			window.location.href = this.ViewURL_Preview + "?saveId=" + order.editId + "&saveId2=" + order.idx + "&addOrder=" + order.addOrder;
		}
	}

	/**
	 * 全画像読み込み判定
	 * */
	private updateOrderImgComplete(): void {
		this._vue.$data.orderImgComplete.push("OK");
		if (this._vue.$data.orderImgComplete.length == this._vue.$data.orderInfos.length) {
			Logger.log('img load all complete');
			dialogUtil.closeLoading();
		}
	}

	/**
	 * 画像読み込み
	 * @param order
	 */
	private getImgUrl(order: AddOrder): string {
		const rt = this.WebAPI_GetEditImage + "?saveId=" + order.editId + "&saveId2=" + order.idx + "";
		return rt;
	}

}


